export default __webpack_public_path__ + "assets/images/ef6d3ec1c049cc3639f3c8f278538142.svg";